import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../Home/Homepage.css";
import "../Trading/CurrencyPairManagementPage.css";
import "../Trading/AddCurrencyPairPage.css";

const STATIC_COINS = ["BTC", "ETH", "USDT", "BNB", "SOL", "XRP", "ADA", "DOGE", "AVAX", "MATIC"];

const AddStakingPackagePage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    coin: "",
    packageName: "",
    apy: "",
    lockDays: 0,
    minAmount: "",
    maxAmount: "",
    description: "",
  });
  const [successModal, setSuccessModal] = useState(null);

  const updateForm = (key, value) => setForm((f) => ({ ...f, [key]: value }));

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    if (!form.coin || !form.packageName || !form.apy) return;
    setSuccessModal({
      packageName: form.packageName,
      coin: form.coin,
      apy: form.apy,
      lockDays: form.lockDays,
    });
  };

  const handleSuccessClose = () => {
    setSuccessModal(null);
    navigate("/dashboard/staking-packages");
  };

  return (
    <main className="dashboard-main dashboard-subpage addpair-page">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <Link to="/dashboard/staking-packages">Staking</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Add Package</span>
          </p>
          <h1 className="dashboard-hero__title">Add Staking Package</h1>
          <p className="dashboard-hero__subtitle">Create a new staking package for users</p>
        </div>
        <div className="dashboard-hero__icon addpair-hero__icon">
          <i className="fas fa-coins" />
        </div>
      </section>

      <div className="dashboard-body addpair-body">
        <div className="addpair-card">
          <form onSubmit={handleSubmit} className="addpair-form">
            <div className="addpair-config-grid">
              <div className="cp-field">
                <label>Coin <span className="required">*</span></label>
                <div className="cp-input-wrap">
                  <i className="fas fa-gem" />
                  <select
                    value={form.coin}
                    onChange={(e) => updateForm("coin", e.target.value)}
                    required
                  >
                    <option value="">Select Coin</option>
                    {STATIC_COINS.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="cp-field">
                <label>Package Name <span className="required">*</span></label>
                <div className="cp-input-wrap">
                  <i className="fas fa-tag" />
                  <input
                    type="text"
                    placeholder="e.g. ETH Staking 30D"
                    value={form.packageName}
                    onChange={(e) => updateForm("packageName", e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="cp-field">
                <label>APY (%) <span className="required">*</span></label>
                <div className="cp-input-wrap">
                  <i className="fas fa-percent" />
                  <input
                    type="number"
                    step="0.01"
                    min={0}
                    placeholder="5.5"
                    value={form.apy}
                    onChange={(e) => updateForm("apy", e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="cp-field">
                <label>Lock Period (Days)</label>
                <div className="cp-input-wrap">
                  <i className="fas fa-lock" />
                  <input
                    type="number"
                    min={0}
                    placeholder="0 = Flexible"
                    value={form.lockDays}
                    onChange={(e) => updateForm("lockDays", Number(e.target.value) || 0)}
                  />
                </div>
              </div>
              <div className="cp-field">
                <label>Min Amount</label>
                <div className="cp-input-wrap">
                  <i className="fas fa-coins" />
                  <input
                    type="number"
                    step="any"
                    min={0}
                    placeholder="1"
                    value={form.minAmount}
                    onChange={(e) => updateForm("minAmount", e.target.value)}
                  />
                </div>
              </div>
              <div className="cp-field">
                <label>Max Amount</label>
                <div className="cp-input-wrap">
                  <i className="fas fa-coins" />
                  <input
                    type="number"
                    step="any"
                    min={0}
                    placeholder="100"
                    value={form.maxAmount}
                    onChange={(e) => updateForm("maxAmount", e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="cp-field">
              <label>Description (optional)</label>
              <div className="cp-input-wrap">
                <textarea
                  rows={3}
                  placeholder="Package details..."
                  value={form.description}
                  onChange={(e) => updateForm("description", e.target.value)}
                  style={{ width: "100%", padding: "0.65rem", border: "none", background: "none" }}
                />
              </div>
            </div>
            <div className="addpair-actions">
              <Link to="/dashboard/staking-packages" className="cp-btn cp-btn--outline">Cancel</Link>
              <button type="submit" className="cp-btn cp-btn--primary">
                <i className="fas fa-check" /> Create Package
              </button>
            </div>
          </form>
        </div>
      </div>

      {successModal && (
        <div className="addpair-success-overlay" onClick={handleSuccessClose}>
          <div className="addpair-success-modal" onClick={(e) => e.stopPropagation()}>
            <div className="addpair-success-icon"><i className="fas fa-check-circle" /></div>
            <h3>Package Created Successfully</h3>
            <p>Staking package has been created (static demo):</p>
            <div className="addpair-success-details">
              <div className="addpair-success-row"><span>Package</span><strong>{successModal.packageName}</strong></div>
              <div className="addpair-success-row"><span>Coin</span><strong>{successModal.coin}</strong></div>
              <div className="addpair-success-row"><span>APY</span><strong>{successModal.apy}%</strong></div>
              <div className="addpair-success-row"><span>Lock Period</span><strong>{successModal.lockDays === 0 ? "Flexible" : `${successModal.lockDays} days`}</strong></div>
            </div>
            <button type="button" className="cp-btn cp-btn--primary" onClick={handleSuccessClose}>Done</button>
          </div>
        </div>
      )}
    </main>
  );
};

export default AddStakingPackagePage;
